<div>
    <div>
        <h3>Create Email</h3>
    </div>
    @if (!submitted) {
    <form [formGroup]="tempForm" (ngSubmit)="submit()" class="form">

        @if (!tempForm.get('templateId')?.value) {
        <div class="template-selection-container">
            <mat-label class="section-label">Select a Template</mat-label>
            <div class="template-grid">
                @for (tpl of templates; track tpl.id) {
                <div class="template-card" [class.selected]="tempForm.get('templateId')?.value === tpl.id"
                    (click)="tempForm.patchValue({templateId: tpl.id})">
                    <div class="card-icon">
                        <mat-icon>{{ tpl.icon }}</mat-icon>
                    </div>
                    <div class="card-content">
                        <span class="tpl-name">{{ tpl.name }}</span>
                        <span class="tpl-desc">{{ tpl.description }}</span>
                    </div>
                    <div class="selection-indicator">
                        <mat-icon *ngIf="tempForm.get('templateId')?.value === tpl.id">check_circle</mat-icon>
                    </div>
                </div>
                }
            </div>
            <input type="hidden" formControlName="templateId">
            <mat-error *ngIf="tempForm.get('templateId')?.invalid && submitted">
                Please select a template to continue
            </mat-error>
        </div>


        }

        @if (tempForm.get('templateId')?.value) {
        <div class="selected-template-banner">
            <span>Template Selected: {{ selectedTemplateName }}</span>
            <button mat-button color="accent" type="button" (click)="tempForm.get('templateId')?.setValue(null)">
                Change Template
            </button>
        </div>
        <hr class="divider">
        <div class="form-row row-2">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Name</mat-label>
                <input matInput formControlName="senderName">
                <mat-error>Your Name is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Title</mat-label>
                <input matInput formControlName="senderTitle">
                <mat-error>Your Title is required</mat-error>
            </mat-form-field>
        </div>

        <div class="form-row row-2">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Email</mat-label>
                <input matInput formControlName="senderEmail" type="email">
                <mat-error>Valid email is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Phone</mat-label>
                <input matInput formControlName="senderPhone" mask="(000) 000-0000" [showMaskTyped]="false"
                    [dropSpecialCharacters]="false">
                <mat-error>Sender Phone is required</mat-error>
            </mat-form-field>
        </div>
        <div class="form-row row-1" *ngIf="tempForm.get('templateId')?.value == 1">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Number of Properties</mat-label>
                <input matInput formControlName="numberOfProperties" type="number">
            </mat-form-field>
        </div>
        <div class="form-row row-2">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Send to Name</mat-label>
                <input matInput formControlName="sendToName">
                <mat-error>Recipient name is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Send to Email</mat-label>
                <input matInput formControlName="sendToEmail" type="email">
                <mat-error>Recipient email is required</mat-error>
            </mat-form-field>
        </div>

        <div class="form-row row-1">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subjectInput">
                <mat-error>Subject is required</mat-error>
            </mat-form-field>
        </div>
        }


        <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between;">
            <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="onCancel()">
                <i class="fa-solid fa-ban"></i>
                Cancel
            </button>
            <button mat-flat-button class="metallic-text-btn-blue" type="submit" [disabled]="loading">
                <i class="fa-solid fa-paper-plane"></i>
                {{ loading ? 'Sending...' : 'Send' }}
            </button>
        </div>
    </form>
    }
    @if (submitted && loading) {
    <div class="loader-container">
        <app-loader></app-loader>
        <h3>Submitting Email...</h3>
    </div>
    }
    @if (submitted && !loading && successful) {
    <div class="success-container">
        <app-success-error [success]="true"></app-success-error>
        <h3>Email Sent Successfully</h3>
        <p>Would you like to send another?</p>
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between;">
            <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="onCancel()">
                <i class="fa-solid fa-ban"></i>
                Cancel
            </button>
            <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="submitAnother()">
                <i class="fa-solid fa-add"></i>
                Submit Another
            </button>
        </div>
    </div>
    }
</div>